module.exports = {"420222100":"兴国镇","420222101":"富池镇","420222102":"黄颡口镇","420222103":"韦源口镇","420222104":"太子镇","420222105":"大王镇","420222106":"陶港镇","420222107":"白沙镇","420222108":"浮屠镇","420222109":"三溪镇","420222110":"龙港镇","420222111":"洋港镇","420222112":"排市镇","420222113":"木港镇","420222114":"枫林镇","420222115":"王英镇","420222451":"率洲农场","420222452":"半壁山农场","420222453":"荆头山农场","420222455":"金海开发区","420222456":"城东新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420222.json
// module id = 1715
// module chunks = 0